module.exports = __webpack_public_path__ + "static/media/default-map-thumbnail.ed3ada66.png";